import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { KrampPriceExportState, KrampPriceExportStateForUpdate } from './kramp-price-export-state-types';

@Injectable({
  providedIn: 'root',
})
export class PricingExportService {
  private readonly krampPriceExportStateUrl: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceUrl: string,
    readonly http: HttpClient
  ) {
    this.krampPriceExportStateUrl = baseServiceUrl + '/kramp-pricing/export/state';
  }

  getKrampPriceExportState(): Observable<KrampPriceExportState> {
    return this.http.get<KrampPriceExportState>(this.krampPriceExportStateUrl);
  }

  updateKrampPriceExportState(updateData: KrampPriceExportStateForUpdate): Observable<KrampPriceExportState> {
    return this.http
      .patch<KrampPriceExportState>(this.krampPriceExportStateUrl, updateData)
      .pipe(switchMap(() => this.getKrampPriceExportState()));
  }
}
